// CardTable.js
import React from 'react';
import CardItem from './component/cardItem';
import { Empty } from 'antd';
import { getQueryStringArgs } from '@/utils/url-parse';
import DragAndDropHOC from './component/dragAndDropHOC';
import Requests from '@/services/request';
import $i18n from '@/i18n';

import './index.less';

class DragCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newRender: false,
      tagLists: [],
    };
  }

  // 初始化数据
  componentDidMount = () => {
    this.getTagLists();
  };

  // 获取标签数据
  getTagLists = () => {
    const { channelCode } = getQueryStringArgs();
    Requests.post('/rest/intercnn/channel/tag/list', { channelCode }).then((res) => {
      this.setState({
        tagLists: res,
      });
    });
  };

  // 卡片重新排序
  moveSort = (dragIndex, hoverIndex) => {
    const { channelCode } = getQueryStringArgs();
    const cardList = this.props.bindAppList;
    const tmp = cardList[dragIndex];
    const params = {
      categoryId: this.props.checkItem,
      channelCode,
      miniappCode: tmp.miniappCode,
      order: hoverIndex,
    };
    Requests.post('/rest/intercnn/channel/category/miniapp/reorder', params).then((res) => {
      if (res) {
        this.props.getBindAppList();
      }
    });
  };

  // 卡片重新render
  newRenderFn = () => {
    this.setState({
      newRender: !this.state.newRender,
    });
  };

  render() {
    const { bindAppList, getBindAppList, checkItem } = this.props;
    return bindAppList.length > 0 ? (
      // <DragDropContextProvider backend={HTML5Backend} key={Math.random() * 1000000}>
      //   <div className="dragCard">
      //     {bindAppList.map((value, index) => {
      //       return (
      //         <CardItem
      //           key={index}
      //           index={index}
      //           value={value}
      //           getBindAppList={getBindAppList}
      //           checkItem={checkItem}
      //           newRender={this.state.newRender}
      //           moveSort={this.moveSort}
      //           newRenderFn={this.newRenderFn}
      //           tagLists={this.state.tagLists}
      //           getTagLists={this.getTagLists}
      //         />
      //       );
      //     })}
      //   </div>
      // </DragDropContextProvider>
      <DragAndDropHOC.HTML5 {...this.props}>
        <div className="dragCard">
          {bindAppList.map((value, index) => {
            return (
              <CardItem
                key={index}
                index={index}
                value={value}
                getBindAppList={getBindAppList}
                checkItem={checkItem}
                newRender={this.state.newRender}
                moveSort={this.moveSort}
                newRenderFn={this.newRenderFn}
                tagLists={this.state.tagLists}
                getTagLists={this.getTagLists}
              />
            );
          })}
        </div>
      </DragAndDropHOC.HTML5>
    ) : (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <span>
            {$i18n.get({
              id: 'aopf.pages.miniAppStore.setting.category.list.no.data',
              dm: '暂无数据',
            })}
          </span>
        }
      />
    );
  }
}

export default DragCard;
